<!--
 * @Description: 项目核场记录管理列表
-->
<template>
  <scroll-layout class="inspection-record-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <ykc-table
      ref="YkcTable"
      operateFixedType="right"
      :data="tableData"
      title="核场记录列表"
      :columns="tableColumns"
      :operateButtons="tableOperateButtons">
      <template #headerButtons>
        <div class="table-header-button">
          <ykc-button type="plain" @click="handleAdd">新增</ykc-button>
          <ykc-button type="plain" @click="doExportFile">导出</ykc-button>
        </div>
      </template>

      <ykc-pagination
        align="right"
        slot="pagination"
        ref="YkcPagination"
        :total="pageInfo.total"
        :page-size.sync="pageInfo.size"
        :current-page.sync="pageInfo.current"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"></ykc-pagination>
    </ykc-table>

    <!-- 提交立项弹窗：选择BD人员 -->
    <el-dialog
      title="提交立项"
      :visible.sync="bdDialogVisible"
      width="440px"
      :close-on-click-modal="false">
      <el-form label-width="90px" @submit.native.prevent>
        <el-form-item label="BD人员" required>
          <el-select
            v-model="selectedBdId"
            filterable
            :loading="bdLoading"
            placeholder="请输入姓名或手机号搜索"
            style="width: 100%">
            <el-option
              v-for="item in bdOptions"
              :key="item.id"
              :label="`${item.accountName}（${item.phone}）`"
              :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="bdDialogVisible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="bdSubmitting"
          @click="handleConfirmSubmitInitiation">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </scroll-layout>
</template>

<script>
  import {
    inspectionRecordPage,
    inspectionRecordSubmitInitiation,
    accountManage,
  } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'InspectionRecordList',
    data() {
      return {
        // 临时隐藏提交立项按钮，恢复时改为 false
        hideSubmitInitiation: true,
        tableData: [],
        pageInfo: {
          current: 1,
          size: 10,
          total: 0,
        },
        searchParams: {
          projectName: '',
          verifierName: '',
          isDraft: '',
          verificationDate: [],
          verificationDateStart: '',
          verificationDateEnd: '',
        },
        // 提交立项-选择BD人员弹窗
        bdDialogVisible: false,
        bdLoading: false,
        bdLoaded: false,
        bdOptions: [],
        selectedBdId: null,
        currentInitiationRecordId: null,
        bdSubmitting: false,
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'projectName',
            label: '项目名称',
            placeholder: '请输入项目名称',
          },
          {
            comName: 'YkcInput',
            key: 'verifierName',
            label: '核场人',
            placeholder: '请输入核场人',
          },
          {
            comName: 'YkcDropdown',
            key: 'isDraft',
            label: '是否为草稿',
            placeholder: '全部',
            data: [
              { id: '', name: '全部' },
              { id: 'yes', name: '是' },
              { id: 'no', name: '否' },
            ],
          },
          {
            comName: 'YkcDatePicker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            key: 'verificationDate',
            label: '核场时间',
          },
        ];
      },
      tableColumns() {
        return [
          {
            label: '核场记录编码',
            prop: 'recordCode',
            minWidth: 160,
            scopedSlots: {
              default: ({ row }) => {
                return <span class="record-code">{row.recordCode || '-'}</span>;
              },
            },
          },
          { label: '项目名称', prop: 'projectName', minWidth: 180 },
          { label: '所在省份', prop: 'province', minWidth: 100 },
          { label: '城市', prop: 'city', minWidth: 100 },
          { label: '区/县', prop: 'district', minWidth: 100 },
          {
            label: '状态',
            prop: 'status',
            minWidth: 120,
            align: 'center',
            scopedSlots: {
              default: ({ row }) => {
                const s = String(row.status).toUpperCase();
                const isDraft = s === 'DRAFT';
                const isInitiated = s === 'INITIATION_SUBMITTED';
                const statusClass = isDraft
                  ? 'status-draft'
                  : isInitiated
                  ? 'status-initiated'
                  : 'status-submitted';
                const text = isDraft ? '草稿' : isInitiated ? '已提交立项' : '已提交';
                const icon = isDraft ? 'el-icon-document' : 'el-icon-circle-check';
                return (
                  <span class={statusClass}>
                    <i class={icon}></i> {text}
                  </span>
                );
              },
            },
          },
          { label: '核场人', prop: 'creatorName', minWidth: 100 },
          { label: '核场时间', prop: 'inspectionDate', minWidth: 160 },
          { label: '最后编辑人', prop: 'lastEditor', minWidth: 100 },
          { label: '最后编辑时间', prop: 'lastEditTime', minWidth: 160 },
        ];
      },
      tableOperateButtons() {
        return [
          {
            enabled: () => true,
            render: (h, data, { row }) => {
              return (
                <ykc-button type="text" onClick={() => this.handleDetail(row)}>
                  详情
                </ykc-button>
              );
            },
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => {
              // 已提交立项状态的核场记录不可再更新
              if (String(row.status || '').toUpperCase() === 'INITIATION_SUBMITTED') return null;
              return (
                <ykc-button type="text" onClick={() => this.handleEdit(row)}>
                  更新
                </ykc-button>
              );
            },
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => {
              // 临时隐藏提交立项按钮（hideSubmitInitiation），仅已提交状态可提交立项
              if (this.hideSubmitInitiation || String(row.status || '').toUpperCase() !== 'SUBMITTED') return null;
              return (
                <ykc-button type="text" onClick={() => this.handleSubmitInitiation(row)}>
                  提交立项
                </ykc-button>
              );
            },
          },
        ];
      },
    },
    beforeRouteEnter(to, from, next) {
      next(vm => vm.requestList());
    },
    created() {
      this.requestList();
    },
    activated() {
      this.requestList();
    },
    watch: {
      $route() {
        this.requestList();
      },
    },
    methods: {
      handleRefresh() {
        this.pageInfo.current = 1;
        this.requestList();
      },
      requestList() {
        const params = {
          keyword: [this.searchParams.projectName, this.searchParams.verifierName]
            .filter(Boolean)
            .join(' '),
          current: this.pageInfo.current,
          size: this.pageInfo.size,
        };
        // 是否为草稿筛选：yes=DRAFT, no=SUBMITTED, 全部不传
        if (this.searchParams.isDraft === 'yes') {
          params.status = 'DRAFT';
        } else if (this.searchParams.isDraft === 'no') {
          params.status = 'SUBMITTED';
        }
        // 处理日期范围
        if (this.searchParams.verificationDate && this.searchParams.verificationDate.length === 2) {
          params.verificationDateStart = this.searchParams.verificationDate[0];
          params.verificationDateEnd = this.searchParams.verificationDate[1];
        }

        inspectionRecordPage(params)
          .then(res => {
            this.tableData = res?.records || [];
            this.pageInfo.total = res?.total || 0;
          })
          .catch(err => {
            console.error('获取列表失败:', err);
          });
      },
      handleSearchConfirm() {
        this.pageInfo.current = 1;
        this.requestList();
      },
      handleSearchClean() {
        Object.assign(this.searchParams, {
          projectName: '',
          verifierName: '',
          isDraft: '',
          verificationDate: [],
          verificationDateStart: '',
          verificationDateEnd: '',
        });
        this.pageInfo.current = 1;
        this.requestList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.size = size;
        this.requestList();
      },
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      handleAdd() {
        this.$router.push({ name: 'inspectionRecordAdd' });
      },
      handleEdit(row) {
        this.$router.push({ name: 'inspectionRecordEdit', query: { id: row.id } });
      },
      handleDetail(row) {
        this.$router.push({ name: 'inspectionRecordDetail', query: { id: row.id } });
      },
      // 提交立项：先确认提示，再弹出BD人员选择弹窗
      handleSubmitInitiation(row) {
        this.$confirm('提交立项后，核场记录将无法修改，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.currentInitiationRecordId = row.id;
            this.selectedBdId = null;
            this.bdDialogVisible = true;
            this.requestBdAccounts();
          })
          .catch(() => {});
      },
      // 获取BD角色账号列表（姓名、手机号）
      requestBdAccounts() {
        if (this.bdLoaded) return;
        this.bdLoading = true;
        accountManage
          .getUserAccountByBd()
          .then(res => {
            this.bdOptions = res || [];
            this.bdLoaded = true;
          })
          .catch(err => {
            console.error('获取BD人员列表失败:', err);
          })
          .finally(() => {
            this.bdLoading = false;
          });
      },
      // 确认提交立项：后端调用飞书获取所选BD人员和提交人的飞书用户id
      handleConfirmSubmitInitiation() {
        if (!this.selectedBdId) {
          this.$message.warning('请选择BD人员');
          return;
        }
        this.bdSubmitting = true;
        inspectionRecordSubmitInitiation({
          recordId: this.currentInitiationRecordId,
          bdAccountId: this.selectedBdId,
        })
          .then(() => {
            this.bdDialogVisible = false;
            this.$message.success('提交立项成功');
            // 刷新列表数据（保持当前分页）
            this.requestList();
          })
          .catch(err => {
            console.error('提交立项失败:', err);
          })
          .finally(() => {
            this.bdSubmitting = false;
          });
      },
      doExportFile() {
        const jsonNode = {
          keyword: [this.searchParams.projectName, this.searchParams.verifierName]
            .filter(Boolean)
            .join(' '),
        };
        if (this.searchParams.isDraft === 'yes') {
          jsonNode.status = 'DRAFT';
        } else if (this.searchParams.isDraft === 'no') {
          jsonNode.status = 'SUBMITTED';
        }
        offlineExport(
          {
            downloadType: 'project_verification_export',
            jsonNode,
          },
          this.pageInfo.total
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  .inspection-record-list {
    .record-code {
      font-family: 'Courier New', monospace;
      font-size: 13px;
      color: #0f172a;
      background: #f1f5f9;
      padding: 2px 8px;
      border-radius: 4px;
    }

    .status-submitted {
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      background: #d1fae5;
      color: #065f46;
    }

    .status-initiated {
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      background: #dbeafe;
      color: #1e40af;
    }

    .status-draft {
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      background: #fef3c7;
      color: #92400e;
    }
  }
</style>
